import { chain } from 'lodash';
import { useMemo } from 'react';

import { PractitionerReceptionServiceSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { Money } from '@dreryk/money-common-api';

import { PriceText } from '../../../shared/components/PriceText';

type ReceptionServicePriceCellProps = {
   readonly defaultMinPrice: Money;
   readonly defaultMaxPrice: Money;
   readonly practitioners: PractitionerReceptionServiceSimple[];
};

export const ReceptionServicePriceCell = (props: ReceptionServicePriceCellProps): JSX.Element => {
   const [minPrice, maxPrice] = useMemo(() => {
      const allPrices = chain(props.practitioners)
         .map((practitioner) => [
            practitioner.minPrice?.asNumber() ?? props.defaultMinPrice.asNumber(),
            practitioner.maxPrice?.asNumber() ?? props.defaultMaxPrice.asNumber(),
         ])
         .flatten()
         .value();

      return [Money.of(Math.min(...allPrices)), Money.of(Math.max(...allPrices))];
   }, [props.practitioners, props.defaultMinPrice, props.defaultMaxPrice]);

   return <PriceText testId={'price'} min={minPrice} max={maxPrice} />;
};
